import React, { SVGProps } from 'react';

// 18px-grid variant of MatchbackIcon, as designed for compact spots like the delete modal.
const MatchbackSmallIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 14C8.76142 14 11 11.7614 11 9C11 6.23858 8.76142 4 6 4C3.23858 4 1 6.23858 1 9C1 11.7614 3.23858 14 6 14Z"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 14C14.7614 14 17 11.7614 17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9C7 11.7614 9.23858 14 12 14Z"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MatchbackSmallIcon;
